<!--
  - Copyright (c) 2023. Haodong JU
  -->

<script>

import { dragscroll } from 'vue-dragscroll/src/main'
import LastStepButton from '@/views/SaaS/widget/LastStepButton.vue'

export default {
  name: 'SaaSChildPageContainer',
  components: { LastStepButton },
  directives: {
    dragscroll
  },
  props: {
    useReturn: {},
    loading: {}
  }
}
</script>

<template>
  <div
    v-dragscroll
    style="height: 100vh;width: 100%;position: relative;overflow-y: hidden"
    :class="!$vuetify.breakpoint.mobile ? 'px-16' : 'px-4'"
  >
    <div
      class="d-flex justify-center flex-column py-16"
      style="width: 100%;height: fit-content;min-height: 100vh"
    >
      <template v-if="loading">
        <div
          class="d-flex align-center justify-center flex-column"
          style="height: 300px"
        >
          <v-progress-circular
            indeterminate
            size="36"
          />
          <div class="mt-6 text-body-1">
            {{ $t('waitAMoment') }}
          </div>
        </div>
      </template>
      <template v-else>
        <last-step-button
          v-if="useReturn"
          @back="$emit('back')"
        />
        <div
          class="mt-16"
          style="max-width: 800px"
        >
          <slot name="title" />
        </div>
        <slot />
        <div>
          <slot name="actions" />
        </div>
      </template>
    </div>
  </div>
</template>

<style>
.btnContentSelect .v-btn, .btnContentSelect .v-btn__content{
  width: 100% !important;
}
</style>
